// @ts-nocheck
import React from 'react';
import { useStateListContext } from 'components/grid/api-list/hooks/list-context';
import {
  getInitialSearch,
  getListStateKeys,
} from 'components/grid/api-list/hooks/list-context/utils';
import { watchForEffectInputs } from 'utils/react';
import {
  isDefined,
  jsonParseObjectValues,
  jsonStringifyObjectValues,
  notEqual,
  parseQueryString,
  stringifyQueryParams,
} from 'utils';

import { get, isEmpty, isString, omit, pick } from 'lodash';

export const useRouterListContext = (props) => {
  const [state, setState] = useStateListContext(getInitialState(props));

  // Only when component is mounted
  React.useEffect(() => {
    props.history.listen((location, action) => {
      if (action === 'POP') {
        const urlState = getStateFromUrl();
        // If urlState exists and it's not equal to initial state...set urlState as initial state
        if (notEqual(urlState, state.getListState())) {
          setState(urlState);
        }
      }
    });
  }, []);

  // On every state change for list state keys
  React.useEffect(() => {
    setContextToUrl();
  }, watchForEffectInputs(state, state.getListStateKeys()));

  function getInitialState() {
    const queryStringObject = parseQueryString(props.location.search);

    const urlState = getStateFromUrl();

    const listStateFromProps = pick(props, getListStateKeys());

    if (isEmpty(queryStringObject)) {
      setContextToUrl(listStateFromProps);
    } else if (notEqual(urlState, listStateFromProps)) {
      // If urlContext exists and it's not equal to initial state...set urlContext as initial state
      return { ...props, ...urlState };
    }

    return props;
  }

  function getStateFromUrl() {
    const query = parseQueryString(props.location.search);

    const filter = jsonParseObjectValues(
      omit(query, ['page', 'perPage', 'sort' /*, 'search'*/]),
    );

    const search = get(query, 'search', getInitialSearch(props));

    return {
      page: parseInt(get(query, 'page', props.page), 10),
      perPage: parseInt(get(query, 'perPage', props.perPage), 10),
      search: query.search || props.search,
      sort: query.sort || props.sort,
      filter: isEmpty(filter) ? props.filter : filter,
    };
  }

  function setContextToUrl(context = state.getListState()) {
    const queryParams = buildQueryParametersFromContext(context);
    setQueryParams(queryParams);
  }

  function buildQueryParametersFromContext(context) {
    return Object.entries(context).reduce((query, [name, value]) => {
      if (name === 'filter') {
        return { ...query, ...jsonStringifyObjectValues(value) };
      }

      /*if (name === 'search' && value) {
        if (isDefined(value.fields) && isDefined(value.query)) {
          return { ...query, search: JSON.stringify(value) };
        }
        return query;
      }*/

      return { ...query, [name]: value };
    }, {});
  }

  function setQueryParams(query) {
    const { location, history } = props;

    history.push({
      ...location,
      search: stringifyQueryParams(query),
    });
  }

  return [state, setState];
};

export default useRouterListContext;
